var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cruisemap"},[(_vm.isOffice)?_c('button',{on:{"click":_vm.updateRoute}},[_vm._v(" Reload route from api ")]):_vm._e(),_c('div',{ref:"map",staticClass:"width100",staticStyle:{"height":"350px"},attrs:{"id":"center-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }